import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";
import { SERVICES } from "@/lib/content";

export default function Services() {
  return (
    <section id="services" className="border-b border-line bg-cream">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Eyebrow>What We Do</Eyebrow>
                <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-navy sm:text-5xl">
                  Services
                </h2>
                <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-body">
                  Focused capabilities spanning the full lifecycle of a face-to-face fundraising
                  campaign — from first plan to field delivery and reporting.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul>
              {SERVICES.map((s, i) => (
                <li key={s.title}>
                  <Reveal delay={i * 0.04}>
                    <div className="group flex items-baseline gap-6 border-t border-line py-7">
                      <span className="w-8 shrink-0 font-display text-sm font-medium text-brand-green">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <div>
                        <h3 className="font-display text-xl font-medium text-navy transition-transform duration-300 group-hover:translate-x-1 sm:text-2xl">
                          {s.title}
                        </h3>
                        <p className="mt-2 max-w-xl text-base leading-relaxed text-slate-body">
                          {s.body}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
